// extracted by mini-css-extract-plugin
module.exports = {"panel":"BluePanel_panel__3JcJ1"};